import Group from 'components/utils/Group'
import LinePlaneDepartureIcon from 'LuxKit/Icons/line/LinePlaneDepartureIcon'
import Label from 'LuxKit/Label'
import BodyText from 'LuxKit/Typography/BodyText'
import styled from 'styled-components'
import { rem } from 'polished'

const SpecialOfferGroup = styled(Group)`
  margin-top: ${rem(4)};
`

interface Props {
  specialOfferLabel: string
  fnfInventoryMessage: string
  isHorizontal?: boolean
}

function MaldivesFnfSpecialOffer({
  specialOfferLabel,
  fnfInventoryMessage,
  isHorizontal = false,
}: Props) {
  return (
    <SpecialOfferGroup direction={isHorizontal ? 'horizontal' : 'vertical'} horizontalAlign="center" verticalAlign="center" gap={4}>
      <Label kind="primary" variant="highlight" format="propercase">
        {specialOfferLabel}
      </Label>
      {fnfInventoryMessage !== '' && (
        <Group direction="horizontal" horizontalAlign="center" verticalAlign="center" gap={4}>
          <LinePlaneDepartureIcon size="XS" colour="neutral-two" />
          <BodyText variant="small" colour="neutral-two">
            {fnfInventoryMessage}
          </BodyText>
        </Group>
      )}
    </SpecialOfferGroup>
  )
}

export default MaldivesFnfSpecialOffer
